<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    role="img"
    aria-hidden="true"
    class="v-icon__svg iconRight"
  >
    <path
      d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'IconRight',
};
</script>

<style lang="scss">
.iconRight {
  color: #CC0000;
}
</style>
